import { ObservableMap } from '@stencil/store';
import { handleThemeChange } from '@uipath/portal-shell-util';

import {
    addThemeMediaListener,
    removeThemeMediaListener,
} from '../../utils/themeHelper';
import { State } from '../types/state';

export function setThemeSideEffect(store: ObservableMap<State>) {
    handleThemeChange(theme => {
        if (store.get('selectedTheme') !== theme) {
            store.set('selectedTheme', theme);

            if (theme === 'autoTheme') {
                addThemeMediaListener(store);
            } else {
                removeThemeMediaListener(store);
            }
        }
    });
}
